import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { ToggleSwitch } from 'examkrackers-components'
import { getIsPreviewAdmin } from 'modules/auth/ducks/selectors'
import LocalStorageService from 'services/LocalStorageService'
import { LOCAL_STORAGE_KEYS } from 'utils/storage'
import eventEmitter from 'providers/eventEmitter'
import events from 'modules/exam/utils/events'

export const PreviewAdminExplanationToggle = ({ currentPage }): JSX.Element => {
  const isPreviewAdmin = useSelector(getIsPreviewAdmin)
  const [isChecked, setIsChecked] = useState(
    LocalStorageService.get(LOCAL_STORAGE_KEYS.previewAdminExplanationToggle)
  )

  const handleChange = e => {
    e.preventDefault()
    setIsChecked(prev => !prev)
    LocalStorageService.set(
      LOCAL_STORAGE_KEYS.previewAdminExplanationToggle,
      !isChecked
    )
    eventEmitter.emit(events.toggleExplanation)
  }

  const isQuestionPage =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      currentPage
    )

  return (
    <>
      {isPreviewAdmin && isQuestionPage && (
        <Container>
          <ToggleContainer onClick={handleChange}>
            Answers:
            <ToggleSwitch checked={isChecked} value={isChecked} statusLabel />
          </ToggleContainer>
        </Container>
      )}
    </>
  )
}

export default PreviewAdminExplanationToggle

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 51px;
  left: 0;
  width: 100%;
`

const ToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  background-color: ${props => props.theme.exam.original.white};
  font-family: Arial;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.1px;
  gap: 5px;
  padding: 0 10px;
`
